import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from 'components/Dialog'

const Field = styled(TextField)`
    width: 100%;

    :not(:last-child) {
        margin-bottom: 20px;
    }
`

class RegulationDialog extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            positive: props.data ? props.data.positive : 'Allow',
            negative: props.data ? props.data.negative : 'Decline'
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleDelete = () => {
        this.props.handleEditorUpdate(this.props.id)
        this.props.handleClose()
    }

    handleEdit = () => {
        const obj = {
            positive: this.state.positive,
            negative: this.state.negative
        }

        if (this.props.data) {
            this.props.handleEditorUpdate(this.props.id, obj)
        } else {
            this.props.insertBlock(this.props.type, obj)
        }

        this.props.handleClose()
    }

    render() {
        const {intl} = this.props

        return (
            <Dialog open={this.props.open} onClose={this.props.handleClose}>
                <DialogTitle>
                    {intl.formatMessage({id: "editor.regulation_settings"})}
                </DialogTitle>
                <DialogContent>
                    <Field
						variant="standard"
                        value={this.state.positive}
                        onChange={this.handleChange}
                        label={intl.formatMessage({id: "editor.positive_label"})}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            name: 'positive'
                        }}
                    />
                    <Field
						variant="standard"
                        value={this.state.negative}
                        onChange={this.handleChange}
                        label={intl.formatMessage({id: "editor.negative_label"})}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            name: 'negative'
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.data &&
                        <Button onClick={this.handleDelete}
                            variant="contained"
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    <Button onClick={this.handleEdit} variant="contained" color="primary">
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default injectIntl(RegulationDialog)
